export const DisplayStatus = Object.freeze({
    EMPTY: Symbol('EMPTY'),
    ERROR: Symbol('ERROR'),
    PROGRESS_OPAQUE: Symbol('PROGRESS_OPAQUE'),
    PROGRESS_TRANSPARENT: Symbol('PROGRESS_TRANSPARENT'),
    VALID: Symbol('VALID'),
})

